import React, { useState } from 'react';
import FileUploader from './FileUploader';
function MainDiv({ jobList }) {
    const [selectedJobIndex, setSelectedJobIndex] = useState(0);
    const userID = new Date().getTime();
    return (
        <>
            {jobList && jobList[0] ?
                (
                    <div className="row">
                        <div className="section-header text-center">
                            <h1>Formulaire De Candidature</h1>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',marginBottom: '30px', color:'#2d3436'}}>
                            <p style={{margin: 0, marginRight: '10px'}}>Canditature pour le poste:</p>
                        <select onChange={(e) => setSelectedJobIndex(e.target.value)}>
                                {jobList.map((el, index) => <option value={index} key={index} onClick={() => setSelectedJobIndex(index)}>{el.title}</option>)}
                            </select>
                        </div>
                        <div className="section-header text-center">
                            <h2 className="title title-text">{jobList[selectedJobIndex].title}</h2>
                        </div>
                        <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center', color: 'black' }}>
                            {jobList[selectedJobIndex].des.split('\n').map((el, index) => <p key={index} className="job-description">{el}</p>)}
                        </div>
                        <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center', color: 'black' }}>
                            <FileUploader userId={`${selectedJobIndex}/${userID}`} updateUserProfilePicture={() => console.log("update called!")} />
                        </div>
                    </div>
                ) : 'loading...'}
        </>
    );
}

export default MainDiv;
